import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { BrandsGateway } from '@domain/gateway/brands-gateway';
import { BrandsModel, BrandsServerModel } from '@domain/entities/brands.model';

@Injectable({
    providedIn: 'root',
})
export class BrandService extends BrandsGateway {
    private endpoint = 'wp-json/wc/v3/products/brands';

    constructor(private _http: HttpClient) {
        super();
    }

    /**
     * @description Get brands
     * @param params (Optional)
     * @returns Observable of brands entity
     */
    read(params?: HttpParams): Observable<BrandsServerModel[]> {
        return this._http.get<BrandsServerModel[]>(
            `${environment.host}${this.endpoint}`,
            {
                params,
            }
        );
    }

    /**
     * @description Create brand
     * @returns Observable of brand entity
     */
    create(form: BrandsModel): Observable<BrandsServerModel> {
        return this._http.post<BrandsServerModel>(
            `${environment.host}${this.endpoint}`,
            form
        );
    }

    /**
     * @description Read a brand
     * @returns Observable of brand entity description
     */
    readById(id: number): Observable<BrandsServerModel> {
        return this._http.get<BrandsServerModel>(
            `${environment.host}${this.endpoint}/${id}`
        );
    }

    /**
     * @description Update brand
     * @returns Observable of brand entity
     */
    update(id: number, form: BrandsModel): Observable<BrandsServerModel> {
        return this._http.put<BrandsServerModel>(
            `${environment.host}${this.endpoint}/${id}`,
            form
        );
    }

    /**
     * @description Delete brand
     * @returns Observable of brand entity
     */
    delete(id: number): Observable<BrandsServerModel> {
        return this._http.delete<BrandsServerModel>(
            `${environment.host}${this.endpoint}/${id}?force=true`
        );
    }
}
